// Vuex requires Promise https://vuex.vuejs.org/installation.html#promise
//import 'es6-promise/auto'
//import 'core-js/stable'
//import 'regenerator-runtime/runtime'
import AddContent from './components/Utils/add-content'
import BlogSearch from './views/blog-search'
// import EventSearch from './views/event-search'
// import ForgottenPassword from './views/forgotten-password'
import KnowledgeLibrarySearch from './views/knowledge-library-search'
import MapsSearch from './views/maps-search'
import MemberBlog from './views/member-blog'
import MemberEvents from './views/member-events'
import MemberNews from './views/member-news'
import MemberProperties from './views/member-properties'
import MemberReports from './views/member-reports'
import MemberSupport from './views/member-support'
// import NewsletterContentBlock from './views/newsletter-content-block'
// import NewsSearch from './views/news-search'
import ProfileActions from './components/Utils/profile-actions'
import PropertyAlerts from './views/property-alerts'
import PropertyMap from './views/property-map'
import PropertySearch from './views/property-search'
import PropertySearchMap from './views/property-search-map'
// import PropertyTabs from './views/property-tabs'
// import ReportSearch from './views/report-search'
import ResendConfirmationEmail from './components/Utils/resend-confirmation-email'
import SearchFilters from './components/SiteSearch/search-filters'
import SiteSearch from './views/site-search'
import StaffSearch from './views/staff-search'
import SupportFinderProfileUpdate from './components/Utils/support-finder-profile-update'
import TagButton from './components/Utils/tag-button'
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import Vuex from 'vuex'
import lodash from 'lodash'
import { createStore } from './store'

Vue.use(VueLodash, { lodash: lodash })
Vue.use(Vuex)

var eventHub = new Vue()
Vue.prototype.$eventHub = eventHub

const store = createStore()

new Vue({
    components: {
        AddContent,
        BlogSearch,
        //EventSearch,
        //ForgottenPassword,
        KnowledgeLibrarySearch,
        MapsSearch,
        MemberBlog,
        MemberEvents,
        MemberNews,
        MemberProperties,
        MemberReports,
        MemberSupport,
        //NewsletterContentBlock,
        //NewsSearch,
        ProfileActions,
        PropertyAlerts,
        PropertyMap,
        PropertySearch,
        PropertySearchMap,
        //PropertyTabs,
        //ReportSearch,
        ResendConfirmationEmail,
        SearchFilters,
        SiteSearch,
        StaffSearch,
        SupportFinderProfileUpdate,
        TagButton
    },

    el: '#hie-app',

    store
})